import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { card } from "@/lib/images";

const ImageCard = ({ to, image, eyebrow, title, text, cta, testId, aspect = "aspect-square", as = "h3" }) => {
  const Heading = as;
  return (
    <Link to={to} data-testid={testId} className="group block">
      <div className={`overflow-hidden bg-stone-200 ${aspect}`}>
        <img
          src={card(image)}
          alt={title}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      {eyebrow && <p className="eyebrow mt-6 text-stone-400">{eyebrow}</p>}
      <Heading className="font-serif mt-3 text-2xl text-stone-900 leading-snug">{title}</Heading>
      {text && <p className="mt-3 text-stone-600 leading-relaxed text-sm">{text}</p>}
      <span className="mt-5 inline-flex items-center gap-2 text-sm text-stone-800 border-b border-stone-300 group-hover:border-stone-900 pb-1 transition-colors">
        {cta} <ArrowRight size={13} />
      </span>
    </Link>
  );
};

export default ImageCard;
